import React, { useEffect, useState } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import Select from "react-select";
import {
  Dropdown,
  DropdownIndicator,
  formatOptionLabel,
} from "../../common/ContractsSelect/common/components";
import "./SelectSearch.scss";
import "./ContractSelectWithRemoteOptionsField.scss";

export default function ContractSelectWithRemoteOptionsField(props) {
  let {
    label,
    placeholder,
    loading,
    noContractFound,
    onSelected,
    contractSelected,
    excludeStatusTypes = [],
    validationSchema,
    ...rest
  } = props;
  const [field, meta, helper] = useField(props);
  const { summaryMode } = rest;
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  const getProperLabel = (field) => {
    let properLabel = field;
    if (typeof field === "object" && field.props && field.props.i18nKey) {
      properLabel = t(field.props.i18nKey);
    }
    return properLabel;
  };

  if (!loading) {
    loading = "Loading";
  }

  if (!noContractFound) {
    noContractFound = "No contract found";
  }

  const { values, setFieldValue, setFieldTouched, status } = useFormikContext();

  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [list, setList] = useState([]);
  const [current, setCurrent] = useState({});
  const nameStatus = `${field.name}-related-field`;

  useEffect(() => {
    if (status) {
      const { [nameStatus]: relatedStatus = [] } = status;
      if (relatedStatus.length > 0) {
        setList(relatedStatus);
        const [firstElement] = relatedStatus;
        setCurrent(firstElement);
        triggerUpdated(firstElement.id);
      }
    }
    const l = list
      .filter((item) => !excludeStatusTypes.includes(item.state))
      .map((contract) => {
        return {
          name: contract.name,
          id: contract.id,
          state: contract.state,
          clientId: contract.clientId,
        };
      });
    setOptions(l);
    // eslint-disable-next-line
  }, [list, excludeStatusTypes, status, nameStatus, current, contractSelected]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const triggerUpdated = (selected) => {
    const currentSelectedContract = list.find((item) => item.id === selected);
    console.log(currentSelectedContract);
    if (onSelected) {
      onSelected(
        currentSelectedContract,
        values,
        setFieldValue,
        setFieldTouched
      );
    }
    setIsOpen(false);
    helper.setValue(selected);
    setValue(currentSelectedContract);
  };

  const filterOption = (candidate, input) => {
    if (input) {
      return Object.values(candidate.data).some((item) => {
        if (!item) {
          return false;
        }
        return (
          item.indexOf(input) !== -1 || item.indexOf(input.toUpperCase()) !== -1
        );
      });
    }
    return true;
  };

  return (
    <Form.Group>
      {!summaryMode ? (
        <>
          <div>
            {label && (
              <Form.Label
                htmlFor={field.name}
                className="paragraph-small-fs9 font-color-1"
              >
                {getProperLabel(label)}
              </Form.Label>
            )}
          </div>
          <Dropdown
            isOpen={isOpen}
            onClose={toggleOpen}
            target={
              <div
                className={`form-control select-remote-options ${isOpen} ${
                  meta.touched && meta.error ? "is-invalid" : ""
                }`}
              >
                <button
                  onClick={toggleOpen}
                  className={
                    "btn btn-contract-select btn-default  select-contracts"
                  }
                  type="button"
                >
                  {value && value.state ? (
                    <>
                      <span className="button-text">{value.name}</span>
                      <span className="gc-icon-functional-chevron-down contract-select-icon" />
                    </>
                  ) : (
                    <>
                      <span className="button-text">
                        {!(current && list)
                          ? getProperLabel(loading)
                          : options.length > 0
                          ? getProperLabel(placeholder)
                          : getProperLabel(noContractFound)}
                      </span>
                      <span className="gc-icon-functional-chevron-down contract-select-icon" />
                    </>
                  )}
                </button>
              </div>
            }
            id={field.name + "-dropdown"}
            required={isRequired}
          >
            <Select
              autoFocus
              backspaceRemovesValue={false}
              value={value}
              formatOptionLabel={formatOptionLabel}
              options={options}
              components={{ DropdownIndicator, IndicatorSeparator: null }}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
              isClearable={false}
              menuIsOpen
              onChange={(data) => triggerUpdated(data.id)}
              className={`gcap-select form-control ${
                meta.touched && meta.error ? "is-invalid" : ""
              }`}
              id={field.name}
              required={isRequired}
              isDisabled={options.length <= 0}
              placeholder={
                options.length > 0
                  ? "Scegli un contratto"
                  : "Nessun contratto disponibile"
              }
              filterOption={filterOption}
              tabSelectsValue={false}
            />
          </Dropdown>

          {meta.touched && meta.error && (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
        </>
      ) : (
        <>
          {label && (
            <span className="paragraph-small-fs9">
              {getProperLabel(label)}
            </span>
          )}
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
